import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

import { Rect, Circle, Polygon } from './styles';

const Apex = memo(({ type, x, y, color, withBorder }) => {
  const points = useMemo(() => {
    switch (type) {
      case 'triangle':
        return `${x - 4}, ${y + 3} ${x},${y - 4} ${x + 4},${y + 3}`;
      case 'rhomb':
      default:
        return `${x - 4},${y} ${x},${y - 4} ${x + 4},${y} ${x},${y + 4}`;
    }
  }, [type, x, y]);

  if (type === 'rect') {
    return (
      <Rect
        x={x - 3}
        y={y - 3}
        width={6}
        height={6}
        color={color}
        data-border={withBorder}
      />
    );
  }

  if (type === 'circle') {
    const radius = withBorder ? '3.5' : '3';

    return (
      <Circle cx={x} cy={y} r={radius} color={color} data-border={withBorder} />
    );
  }

  return <Polygon points={points} color={color} data-border={withBorder} />;
});

Apex.propTypes = {
  type: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
  color: PropTypes.string,
  withBorder: PropTypes.bool,
};

Apex.defaultProps = {
  x: 0,
  y: 0,
  type: 'rhomb',
  color: null,
  withBorder: false,
};

export default Apex;
